module.exports = __webpack_public_path__ + "img/avatar_random_8.8bd40f1c.png";